const KPI_SCOPE = Object.freeze({
  personal: 'personal',
  business: 'business',
  stylists: 'stylists',
});

export default KPI_SCOPE;
